import { render, staticRenderFns } from "./DashboardTitle.html?vue&type=template&id=5313d1c0&scoped=true&external"
import script from "./DashboardTitle.js?vue&type=script&lang=js&external"
export * from "./DashboardTitle.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313d1c0",
  null
  
)

export default component.exports